module.exports = __webpack_public_path__ + "assets/albya-alt.243fd9c5.svg";